import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { Link, usePage } from "@inertiajs/react";
import Layout from "@/components/Layout";
import PersonaForm from "@/components/PersonaForm";
import type { Persona, SharedProps } from "@/types";

type EditProps = {
  persona: Persona;
};

export default function Edit({ persona }: EditProps) {
  const { query_parameters } = usePage<SharedProps>().props;
  const return_to = query_parameters?.return_to;
  const cancelHref = return_to === "index" ? "/personas" : `/personas/${persona.id}`;
  const url = return_to ? `/personas/${persona.id}?return_to=${return_to}` : `/personas/${persona.id}`;

  return (
    <Layout title="Edit Persona">
      <div className="mb-6 flex items-center">
        <Link href={cancelHref} className="mr-4 text-gray-500 hover:text-primary" aria-label="Back">
          <ArrowLeftIcon className="h-6 w-6" />
        </Link>
        <h1 className="text-2xl font-semibold">Edit {persona.name}</h1>
      </div>

      <div className="mx-auto max-w-5xl">
        <PersonaForm
          cancelHref={cancelHref}
          formTitle="Edit Persona"
          method="patch"
          persona={persona}
          submitLabel="Save Persona"
          url={url}
        />
      </div>
    </Layout>
  );
}
